/**
 * O cadastro de operadoras ativas (`GET /operadoras`).
 *
 * Fica em `shared` porque mais de uma tela escolhe operadora: o cadastro de contrato e o filtro da fila de
 * triagem. Uma feature não importa outra (`boundaries` no `eslint.config.js`), e duas cópias da mesma
 * consulta guardariam a mesma lista em duas chaves de cache.
 */

import { queryOptions } from '@tanstack/react-query';

import { requisitar } from '../api/clienteHttp';

/** `GET /operadoras` (schema `PayerListItem`). */
export interface OperadoraApi {
  readonly id: string;
  readonly name: string | null;
}

export interface Operadora {
  readonly id: string;
  readonly nome: string;
}

export function mapearOperadora(bruto: OperadoraApi): Operadora {
  return { id: bruto.id, nome: bruto.name ?? `Operadora ${bruto.id.slice(0, 8)}` };
}

export const chaveDasOperadoras = ['operadoras'] as const;

export function opcoesDasOperadoras() {
  return queryOptions({
    queryKey: chaveDasOperadoras,
    queryFn: ({ signal }): Promise<Operadora[]> =>
      requisitar<OperadoraApi[]>('/operadoras', { sinal: signal }).then((itens) => itens.map(mapearOperadora)),
    // O cadastro muda por curadoria, não durante o uso da tela.
    staleTime: 5 * 60_000,
  });
}
